module.exports = __webpack_public_path__ + "static/trig_003-320058db993a73cbcdd45e1c2af19b30.webp";